<template>
    <ul :class="{ container: useContainer }" class="global-actions">
        <!-- Each visible label sits inside its control so it is the control's
             accessible name; beside it, the icon buttons were unnamed. -->
        <li v-if="useFavorite">
            <GlobalUserActionButton :list="list" :item="item" size="large"><p>Favorite</p></GlobalUserActionButton>
        </li>
        <li v-if="useItinerary">
            <GlobalUserActionButton list="ohcItineraries" :item="item" size="large"><p>Add to Itinerary</p></GlobalUserActionButton>
        </li>
        <li v-if="useDirections">
            <button type="button" @click.prevent="openDirections">
                <SvgsDirections class="svg" />
                <p>Directions</p>
            </button>
        </li>
        <li v-if="startTour">
            <button type="button" @click.prevent="openDirections">
                <SvgsDirections class="svg" />
                <p>Start Tour</p>
            </button>
        </li>
        <li v-if="useDirectionsSingle">
            <GlobalUserDirectionsButton class="svg" :item="item"><p>Directions</p></GlobalUserDirectionsButton>
        </li>
        <li v-if="useShare">
            <GlobalUserShareButton :item="item"><p>Share</p></GlobalUserShareButton>
        </li>
    </ul>
</template>

<script setup>
    const emit = defineEmits(['openDirections']);
    function openDirections() {
        emit('openDirections');
    }

    const props = defineProps({
        useContainer: {
            type: Boolean,
            required: false,
            default: true,
        },

        useFavorite: {
            type: Boolean,
            required: false,
            default: true,
        },

        useItinerary: {
            type: Boolean,
            required: false,
            default: true,
        },

        useDirections: {
            type: Boolean,
            required: false,
            default: true,
        },

        useDirectionsSingle: {
            type: Boolean,
            required: false,
            default: true,
        },

        useShare: {
            type: Boolean,
            required: false,
            default: true,
        },

        startTour: {
            type: Boolean,
            required: false,
            default: false,
        },

        item: {
            type: Object,
            required: false,
            default: {},
        },

        list: {
            type: String,
            required: false,
            default: 'ohcFavoriteSites',
        },
    });
    const { useContainer, useFavorite, useItinerary, useDirections, useShare, item } = toRefs(props);
</script>

<style lang="scss" scoped>
    .global-actions {
        display: flex;
        li {
            width: 55px;
            text-align: center;
            font-size: 12px;
            font-weight: 800;
            line-height: 15px;
            p {
                margin-top: 10px;
            }
            // The label now lives inside the control: stack it under the icon
            // and let it keep the list's type rather than the control's.
            :deep(button),
            :deep(a) {
                display: flex;
                flex-direction: column;
                align-items: center;
                width: 100%;
                font: inherit;
                color: inherit;
                text-decoration: none;
            }
            + li {
                margin-left: 26px;
            }
        }
    }
</style>
